import type { LocationModel } from '../../types/location';

export const getDepthLabel = (option: LocationModel) =>
  ['city', 'level1', 'level2', 'level3'].reduce((acc, item, index) => {
    if (item === option.kind) return acc;
    if (option[item as keyof LocationModel]) {
      return acc + `${index !== 0 ? ', ' : ''}${option[item as keyof LocationModel]}`;
    }
    return acc;
  }, '');
